import { useMemo } from 'react';
import { useGetCatalogQuery, useGetReleaseKitsQuery } from '../../../../redux/api/fymAPI';
import { profileReleasesOf, type ProfileRelease } from './profileReleases';

/** The releases with a cover of the artist, newest first, with the kit look of each. */
export function useProfileReleases(accountId: number): { releases: ProfileRelease[]; isLoading: boolean } {
  const catalog = useGetCatalogQuery({ accountId });
  const kits = useGetReleaseKitsQuery({ accountId });
  const releases = useMemo(() => profileReleasesOf(catalog.data?.items, kits.data?.kits), [catalog.data, kits.data]);
  return { releases, isLoading: catalog.isLoading };
}
